import { EColors } from "common/styles"
import { Styled } from "components/Styled"
import { StyledAddress, StyledAddressItem } from "./styled"
import { TAddress } from "./types"

export const AddressItem = ({ item }: { item: TAddress }) => {
    return (
        <StyledAddressItem>
            <Styled.H4 color={EColors.white}>{item.city}</Styled.H4>
            <StyledAddress color={EColors.white} href={item.href} target='_blank'>{item.address}</StyledAddress>
            <Styled.PBody1 color={EColors.white}>{item.phone}</Styled.PBody1>
        </StyledAddressItem>
    )
}